<template>
    <div class="container-fluid" id="dvcrud">        
        <div class="row">
            <consultafornecedores></consultafornecedores>
            <gerarparcelas v-bind:vproptipo=1></gerarparcelas>
            <baixartitulospagar v-if="baixartitulospagar"  v-bind:vdtbaixa           = "pdtbasebaixa"
                             v-bind:proplstselecionados     = "vvariaveisbaixar.lstselecionadosbaixa"                             
                             v-bind:vvariaveisbaixarcmp     = "vvariaveisbaixar"
                             v-bind:propvaldescontojuros    = "valdescontojuros"
                             v-bind:propvaldescontomulta    = "valdescontomulta"
                             v-bind:propidlancamentopdv     = "0">
            </baixartitulospagar>
            <detalhestitulopagar  v-bind:idfornecedor = "didfornecedor" 
                                    v-bind:codtit    = "dcodtit" 
                                    v-bind:situacao  = "dsituacao">
            </detalhestitulopagar>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar títulos" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Gerar títulos" style="margin-right: 10px;" @click.prevent="mtdgerarparcelas()"><span aria-hidden="true"><i class="fa fa-gears"></i></span></button>
                        <button v-show="mtdverificabalancoanual()" type="button" class="close" data-dismiss="modal" aria-label="Close" title="Mapa anual" style="margin-right: 10px;" @click.prevent="mtdbalancoanual()"><span aria-hidden="true"><i class="fa fa-calendar"></i></span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoriapesq" data-placeholder="Selecione uma categoria" data-allow-clear="true"
                                    v-model="pidcategoria" style="width:100%;">
                                </select>
                            </div>                             
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Tipo de cobrança:</span>
                                <select id="cbtipocobrancapesq" v-model="pidtipocobranca"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>  
                            <div v-show="parseInt(vtipocobrancapesq)===1" class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Sit. Cheque:</span>
                                <select id="cbsitchequepesq" data-placeholder="Selecione uma situação" data-allow-clear="true"
                                    v-model="pidsituacaocheque" style="width:100%;">
                                </select>
                            </div>                                                      
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcodauxiliarpesq">Cód. Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" id="edcodauxiliarpesq" v-model="pcodauxiliar"
                                    maxlength="30" data-bv-group=".group" @change="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edemitentechequepesq">Emitente(Cheque):</label>
                                <input type="text" class="form-control form-control-sm" id="edemitentechequepesq" v-model="pemitentecheque"
                                    maxlength="30" data-bv-group=".group" @change="mtdlimpar_listagem()">
                            </div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbfiltropor">Por:</label>
                                <select class="form-control form-control-sm" id="cbfiltropor" v-model="ppor" @change="mtdlimpar_listagem()">
                                    <option value="0">Dt. Vencimento</option>
                                    <option value="1">Dt. Emissão</option>
                                    <option value="2">Dt. da baixa</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                        
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cblistar">Listar:</label>
                                <select class="form-control form-control-sm" id="cblistar" v-model="pativosinativos" @change="mtdlimpar_listagem()">
                                    <option value="0">Ativos</option>
                                    <option value="1">Inativos</option>
                                    <option value="2" selected="true">Todos</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtbasebaixa">Dt. Base/Baixa:</label>
								<div class="input-group">
									<date-picker id="eddtbasebaixa" v-model="pdtbasebaixa" :config="options" class="form-control form-control-sm" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbSitTitulo">Situação</label>
                                <select class="form-control form-control-sm" id="cbSitTitulo" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Abertos</option>
                                    <option value="1">Baixados</option>
                                    <option value="2">Cancelados</option>
                                </select>
                            </div>
                            <div v-show="parseInt(psituacao) === 1" class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Conta(FC):</span>
                                <select id="cbcontapesq" data-placeholder="Selecione uma opção"
                                    v-model="pidconta" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2 col-md-offset-2 col-lg-offset-2">
                                <label for="cbordempesq">Ordem:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbordempesq" v-model="pordem" @change="mtdlimpar_listagem()">
                                    <option value="0">Fornecedor</option>
                                    <option value="1">Emissão</option>
                                    <option value="2">Vencimento</option>
                                    <option value="3">Pagamento</option>
                                </select>
                            </div>                                                         
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <!-- visualização para abertos e renegociados -->
                            <div v-show="parseInt(psituacao) === 0 || parseInt(psituacao) === 3" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos" @on-select-row="mtdcalculaselecionados()"
                                    @on-unselect-row="mtdcalculaselecionados()"
                                    @on-all-select-rows="mtdcalculaselecionados()"
                                    @on-all-unselect-rows="mtdcalculaselecionados()"
                                        :rows="lsttitulos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                           
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Alterar"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Cancelar"><i class="fa fa-ban"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idfornecedor, item.row.codtit, 'A')" title="Informções"><i class="fa fa-info-circle"></i></button>   
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button>     
                                        </div>
                                                                         
                                    </template>
                                    <template slot="slot_nomefornecedor" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idfornecedor, 8) }} - {{ item.row.nomefornecedor }}
                                    </template>
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                     
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>                                    
                                    <template slot="slot_vlapagar" slot-scope="item">
                                        <span style="color: #5A956A; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlapagar), 2) }}</span>
                                    </template>                                                                         
                                </vue-bootstrap4-table>
                            </div>
                            <!-- visualização dos cancelados -->
                            <div v-show="parseInt(psituacao) === 2" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttitulos"
                                        :columns="columnscancelados"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdestornarcancelamento(item.row)" title="Estornar"><i class="fa fa-mail-reply"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idfornecedor, item.row.codtit, 'C')" title="Informções"><i class="fa fa-info-circle"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button> 
                                        </div>
                                    </template>
                                    <template slot="slot_nomefornecedor" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idfornecedor, 8) }} - {{ item.row.nomefornecedor }}
                                    </template>
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
                                </vue-bootstrap4-table>
                            </div> 
                            <!-- visualização dos baixados -->
                            <div v-show="parseInt(psituacao) === 1" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttitulos"
                                        :columns="columnsbaixados"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex" >
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdestornarbaixa(item.row)" title="Estornar"><i class="fa fa-mail-reply"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idfornecedor, item.row.codtit, 'B')" title="Informções"><i class="fa fa-info-circle"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button>  
                                        </div>
                                    </template>
                                    <template slot="slot_nomefornecedor" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idfornecedor, 8) }} - {{ item.row.nomefornecedor }}
                                    </template>
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template> 
                                    <template slot="slot_valordescontojurosmulta" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.valordescontojurosmulta), 2) }}</span>
                                    </template>                                                                                                             
                                    <template slot="slot_vlpago" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlpagtit) + parseFloat(item.row.vljuros) + parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>                                    
                                </vue-bootstrap4-table>
                            </div>                             
                            <div class="col-md-12">
                                <div v-show="parseInt(psituacao) === 0 || parseInt(psituacao) === 3" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrVencidos, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vrAvencer, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vrJuros, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vrMulta, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total geral <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vrTotal, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Selecionados <span class="badge badge-info bdgtitulos">{{ vqtdtitsel }}</span></a>
                                                    <a class="list-group-item lstdetrec">Soma dos títulos <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vTotalPagarSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vTotalJurosSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vTotalMultaSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total geral à pagar <span
                                                            class="badge badge-success bdgtitulos">{{ mtdformatavalordecimal(vTotalGeralSel, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="parseInt(psituacao) === 1" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total juros <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaljurosrec, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total descontos <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaldescontorec, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotalmultarec, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdetrec">Total pago <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotalgeralrec, 2) }}</span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                                <div v-show="parseInt(psituacao) === 2" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total cancelado(s) <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrTotcancelados, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-2 col-sm-2 col-md-4 col-lg-4" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button v-show="parseInt(psituacao) === 0 && lsttitulos.length > 0 && vqtdtitsel > 0" type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdalterarfornecedor()" title="Alterar fornecedor dos títulos selecionados"><i class="fa fa-address-book"></i> Fornecedor</button>
                            </div>                             
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button v-show="parseInt(psituacao) === 0 && lsttitulos.length > 0 && vqtdtitsel > 0" type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdbaixartitulos()"><i class="fa fa-check"></i> Baixar</button>
                            </div> 
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdabremodalimp()"><i class="fa fa-print"></i> Exportar</button>
                            </div>                                             
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="edcodcli">*Fornecedor:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" id="edcodfor" v-model="vidfornecedor" v-bind:disabled="ativadesativaCodFor" maxlength="11" v-on:blur="mtdlocalizarfornecedor(vidfornecedor)" style="text-transform: uppercase;">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarfornecedor()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-5">
                                <label for="ednomefornecedor">Nome do fornecedor:</label>
                                <input type="text" class="form-control form-control-sm" id="ednomefornecedor" v-model="vnomefornecedor"
                                    data-bv-group=".group" maxlength="50" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="edcodtit">*Nº Título:</label>
                                <input type="text" class="form-control form-control-sm" id="edcodtit" v-model="vcodtit"
                                    v-bind:disabled="ativadesativaCodTit" maxlength="30" style="text-transform: uppercase;"
                                    data-bv-group=".group">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcodtit">Cod. Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" id="edauxiliar" v-model="vcodauxiliar" v-bind:disabled="ativadesativa"
                                    maxlength="30" style="text-transform: uppercase;" data-bv-group=".group">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Tipo de cobrança:</span>
                                <select id="cbtipocobranca" v-model="vidtipocobranca" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemitit" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtvenc">*Dt. Vencimento:</label>
								<div class="input-group">
									<date-picker id="eddtvenc" v-model="vdtventit" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                                                        
                            <div class="col-sm-12" v-show="parseInt(tipocob) === 1">
                                <div class="card" id="pnlcheque" style="margin-top: 15px; margin-bottom: 10px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;"><span>DADOS DO CHEQUE</span></div>
                                    <div class="card-body" style="padding-bottom: 15px;">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="ednumcheque">*Nº Cheque:</label>
                                                <input type="text" class="form-control form-control-sm" id="ednumcheque"
                                                    v-model="vnumerocheque" v-bind:disabled="ativadesativa" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-7">
                                                <span class="lblselect2">*Banco:</span>
                                                <select id="cbbanco" v-model="vidbanco" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um banco" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edagencia">*Agência:</label>
                                                <input type="text" class="form-control form-control-sm" id="edagencia"
                                                    v-model="vagencia" v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edconta">*Conta:</label>
                                                <input type="text" class="form-control form-control-sm" id="edconta" v-model="vconta"
                                                    v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label for="edpraca">*Praça:</label>
                                                <input type="text" class="form-control form-control-sm" id="edpraca" v-model="vpraca"
                                                    v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edemitente">*Emitente:</label>
                                                <input type="text" class="form-control form-control-sm" id="edemitente"
                                                    v-model="vemitente" v-bind:disabled="ativadesativa" maxlength="50"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edcnpjcpfch">*Cnpj/Cpf:</label>
                                                <input type="text" v-mask="['##.###.###/####-##', '###.###.###-##']" class="form-control form-control-sm" id="edcnpjcpfch"
                                                    v-model="vcnpjcpf" v-bind:disabled="ativadesativa" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-9 col-lg-9">
                                                <span class="lblselect2">*Situação do Cheque:</span>
                                                <select id="cbsitcheque" v-model="vidsituacaocheque" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione a situação do cheque" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbsituacao">Situação:</label>
                                <select class="form-control form-control-sm" v-model="vinativo" id="cbsituacao"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Ativo</option>
                                    <option value="1">Inativo</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpjuros">Tipo de juros:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcjuros" id="cbtpjuros"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatjuros">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatjuros" v-bind="money" v-model="vfatjuros"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpmulta">Tipo de multa:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcmulta" id="cbtpmulta"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatmulta">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatmulta" v-bind="money" v-model="vfatmulta"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edvalortit">*Valor do título:</label>
                                <money class="form-control form-control-sm" id="edvalortit" v-bind="money" v-model="vvltit"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right; background: #0acf97; color: white; font-weight: bold;"></money>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="txtobs">Observações:</label>
                                <textarea class="form-control center" rows="4" id="txtobs" v-model="vobstit"
                                        style="text-transform: uppercase;"
                                        v-bind:disabled="ativadesativa"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Confirmar
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">IMPORTAÇÃO DE CONTAS À PAGAR</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">Importação de cadastro</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>                
            </div>
        </div>
		<!-- Modal de alteração do fornecedor -->
		<div class="modal fade" id="mdalterarfornecedor">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-address-book"></i> Alteração de fornecedor do(s) título(s) selecionado(s)</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div  class="col-sm-12 col-md-12 col-lg-12">
                                <span class="lblselect2">*Fornecedor:</span>
                                <select id="cbfornecedoralterar" data-placeholder="Selecione uma forma" v-model="aidfornecedor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                       
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarfornecedor()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>  
        
        <!-- Modal definições de impressão -->
		<div class="modal fade" id="mddefineimp">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-print"></i> Definir exportação</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
                        <div class="col-12">
                            <label for="cbgrupamento">Agrupar:</label>
                            <select class="form-control form-control-sm" id="cbgrupamento" v-model="pgrupamento">
                                <option value="0">Não agrupar</option>
                                <option value="1">Fornecedor</option>
                                <option value="2">Emissão</option>
                                <option value="3">Vencimento</option>
                                <option value="4">Mês</option>
                                <option value="5">Filial</option>
                            </select>
                        </div>  

                        <div v-if="pgrupamento == 1" class="col-6">
                            <label for="cbenderecocli">Informar endereço:</label>
                            <select class="form-control form-control-sm" id="cbenderecocli" v-model="penderecocli">
                                <option value="0">Não informar</option>
                                <option value="1">Informar</option>
                            </select>
                        </div>   

                        <div v-if="pgrupamento == 1" class="col-6">
                            <label for="cbenderecocli">Ordem:</label>
                            <select class="form-control form-control-sm" id="cbenderecocli" v-model="pordemcli">
                                <option value="0">Código</option>
                                <option value="1">Nome/Razão</option>
                                <option value="2">Fantasia</option>
                            </select>
                        </div>  

                        <div v-if="pgrupamento == 4" class="col-6">
                            <label for="cbmes">Filtrar mês por:</label>
                            <select class="form-control form-control-sm" id="cbmes" v-model="pmes">
                                <option value="0">Emissão</option>
                                <option value="1">Vencimento</option>
                            </select>
                        </div>  

                    </div>
				</div>
				<div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-sm corverde" style="width: 100px;" @click.prevent="mtdgerarpdf(0)"><i class="fa fa-file-excel-o"></i> Excel </button>
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdgerarpdf(1)"><i class="fa fa-print"></i> Imprimir</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>   
        

         <div class="modal fade" id="mdlarquivostitulo">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-files-o"></i> Arquivos do título: {{legtituloarq.codtit}}, R$ {{mtdformatavalordecimal(parseFloat(legtituloarq.vlresta), 2)}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 10px;">
                                <div class="card">
                                    <div class="card-body" style="padding: 2px; min-height: 40px;">
                                        <div class="row text-center" style="padding: 15px;">
                                            <div v-for="arquivo in lstarquivostitulo" class="col-md-4 dv-arq-lista">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/'+arquivo.patharquivo" target="_blank">
                                                            <i v-if="extensaocxalta(arquivo.arquivo) === 'JPG' || extensaocxalta(arquivo.arquivo) === 'JPEG'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PDF'" class="fa fa-file-pdf-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'DOC' || extensaocxalta(arquivo.arquivo) === 'DOCX'" class="fa fa-file-word-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'XLS' || extensaocxalta(arquivo.arquivo) === 'XLSX'" class="fa fa-file-excel-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PPT' || extensaocxalta(arquivo.arquivo) === 'PPTX'" class="fa fa-file-powerpoint-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'TXT'" class="fa fa-file-text-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'ZIP' || extensaocxalta(arquivo.arquivo) === 'RAR'" class="fa fa-file-archive-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'MP3'" class="fa fa-file-audio-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'MP4' || extensaocxalta(arquivo.arquivo) === 'AVI'" class="fa fa-file-video-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'HTML'|| extensaocxalta(arquivo.arquivo) === 'HTM'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'CSS'" class="fa fa-css3 icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'JS'"  class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PHP'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'SQL'" class="fa fa-database icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'CSV'" class="fa fa-file-text-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'XML'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'GIF'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PNG'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'BMP'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else class="fa fa-file-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i class="fa fa-close icon-del-arquivo" @click.prevent="mtdexcluirarquivo(arquivo.patharquivo)"></i>
                                                        </a>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <a class="link-arquivo" v-bind:href="'https://'+$store.state.usuario.adrsrv+'/'+arquivo.patharquivo" target="_blank"><h6 class="tit-arquivo">{{ arquivo.arquivo }}</h6></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                                         
                            <div  class="col-md-12 text-center" style="margin-top: 15px;">
                                <input
                                    type="file" 
                                    id="ipselecionarimg"
                                   
                                    @change="mtdselecionararquivotit" 
                                    style="display: none;"
                                    ref="filestit">
                                <button type="button" @click="$refs.filestit.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar arquivo</button>
                            </div>                              
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>            
                </div>
            </div>
        </div>


        
        <div class="modal fade" id="mdbalancoanual" tabindex="-1">
			<div class="modal-dialog modal-xl">
             <!-- gda gdi gda gda o - cotton eye joe 🤠 -->
                <div class="modal-content">
                    
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <i class="fa fa-pie-chart"></i>
                           Mapa anual
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                   
                    <div class="modal-body">

                        <div class="row" style="padding-bottom: 20px;">
                            <div class="col-sm-12 col-md-8 col-lg-6">
                                <label for="cbfiltroperiodo">Selecione o ano:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="vselano">
                                    <option v-for="year in years" :value="year" :key="year">
                                        {{ year }}
                                    </option>
								</select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
                                <button type="button" id="btimprimir" class="btn btn-secondary btn-sm btn-block corverde" @click.prevent="mtdimprimirbalanco(0)"><i class="fa fa-file-excel-o"></i> Excel</button>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
                                <button type="button" id="btimprimir" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdimprimirbalanco(1)"><i class="fa fa-print"></i> Imprimir</button>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
                                <button type="button" id="btbuscaanual" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdbuscabalancoanual()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                        </div>
                     
                        <div class="row">
                            <div class="col-12">
                                <table class="table table-bordered table-responsive table-xl table-anual">
                                    <thead>
                                      <tr>
                                        <th>Filial</th>
                                        <th>Janeiro</th>
                                        <th>Fevereiro</th>
                                        <th>Março</th>
                                        <th>Abril</th>
                                        <th>Maio</th>
                                        <th>Junho</th>
                                        <th>Julho</th>
                                        <th>Agosto</th>
                                        <th>Setembro</th>
                                        <th>Outubro</th>
                                        <th>Novembro</th>
                                        <th>Dezembro</th>
                                        <th>Total geral</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(filial, index) in lstbalancofil" v-bind:key="index" >
                                        <td>{{ filial.descfil}}</td>
                                        <td style="text-align: right;" >{{ mtdformatavalordecimal(parseFloat(filial.janeiro), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.fevereiro), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.marco), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.abril), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.maio), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.junho), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.julho), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.agosto), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.setembro), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.outubro), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.novembro), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.dezembro), 2)}}</td>
                                        <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.totalgeral), 2)}}</td>
                                      </tr>
                                      <tr>
                                        <th colspan="14" style="text-align: center;">TOTALIZADORES</th>
                                      </tr>
                                      <tr>
                                        <td>TOTAL MENSAIS</td>
                                        <td style="text-align: right; font-weight: bold;" >{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.janeiro), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.fevereiro), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.marco), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.abril), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.maio), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.junho), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.julho), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.agosto), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.setembro), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.outubro), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.novembro), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.dezembro), 2)}}</td>
                                        <td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(vtotaisbalancofil.totgeral), 2)}}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                            </div> 
                        </div>
                    </div>			        
                </div>
			</div>
		</div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarFornecedores from '../components/cmpconsultarfornecedores.vue'
    import GerarParcelas from '../components/cmpgerarparcelas.vue'
    import BaixarTitulosPagar from '../components/cmpbaixartitulospagar'
    import DetalhesTituloPagar from '../components/cmpdetalhestitulopagar'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadtitulospagar',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'            : BreadCrumb,
            'consultafornecedores'  : ConsultarFornecedores,
            'gerarparcelas'         : GerarParcelas,
            'baixartitulospagar'    : BaixarTitulosPagar,
            'detalhestitulopagar'   : DetalhesTituloPagar
        },
        data: function() {
            const currentyear = new Date().getFullYear();
            return {

                //modal defnições imp
                pgrupamento         : 0, 
                penderecocli        : 0,
                pordemcli           : 0,
                pmes                : 0,

                vselano             : currentyear,
                lstbalancofil       : [],
                vtotaisbalancofil   : [],

                years               : this.generateyears(2016, 2050),

                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                filiaisusuario      : '',

                lsttitulos          : [],
                pfiltro             : 1,
                pidcategoria        : null,
                pidfilial           : null,
                pidfornecedor       : null,
                pidtipocobranca     : null,
                pidconta            : null,
                pcodauxiliar        : '',
                pemitentecheque     : '',
                pativosinativos     : 0,
                pfiltroperiodo      : 1,
                ppor                : 0,
                hab_desab_periodo   : false,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true), 
                pdtbasebaixa        : util.DataAtual(true),
                psituacao           : 0,
                pordem              : 2,      
                pqtdregistros       : 10,
                pqtd_paginas        : 1,
                pagina_atual        : 1,
                pqtd_total_registros: 0,
                vtipocobrancapesq   : 0,

                 /// modal titulo arquivos
                legtituloarq        : [], 
                lstarquivostitulo   : [], 
                vpatharquivostit    : '',

                //variáveis do crud
                ativadesativaCodFor : false,
                ativadesativaCodTit : false,
                opcrud              : 0,

                tipocob             : 0,//variável para determinar se é cheque ou não

                vidfornecedor       : '',
                vnomefornecedor     : '',
                vcodtit             : '',
                vsttit              : '',
                vcodauxiliar        : '',
                vidtipocobranca     : null,
                vidfilial           : null,
                vdtemitit           : util.DataAtual(true),
                vdtventit           : util.DataAtual(true),
                vnumerocheque       : '',
                vidbanco            : null,
                vagencia            : '',
                vconta              : '',
                vpraca              : '',
                vemitente           : '',
                vcnpjcpf            : '',
                vidsituacaocheque   : null,
                vinativo            : 0,
                vtpcalcjuros        : 0,
                vfatjuros           : 0,
                vtpcalcmulta        : 0,
                vfatmulta           : 0,
                vvltit              : 0,
                vobstit             : '',


                //variável para habilitação dos campos
                ativadesativa       : true,

                //variaveis de somas totais
                vrVencidos          : 0,
                vrAvencer           : 0,
                vrJuros             : 0,
                vrMulta             : 0,
                vrTotal             : 0,
                vrTotcancelados     : 0,

                //variaveis de somas dos baixados
                vtotaltitulosrec    : 0,
                vtotaljurosrec      : 0,
                vtotalmultarec      : 0,
                vtotaldescontorec   : 0,
                vtotalgeralrec      : 0,          

                //variáveis para os totais dos selecionados
                vqtdtitsel          : 0,
                vTotalPagarSel      : 0,
                vTotalJurosSel      : 0,
                vTotalMultaSel      : 0,
                vTotalGeralSel      : 0,                

                //baixa de titulo
                valdescontojuros         : 0,
                valdescontomulta         : 0,
                vvariaveisbaixar : {
                    vtottitbaixa         : 0,
                    vtotmultabaixa       : 0,
                    vtotjurosbaixa       : 0,
                    vtotpagarbaixa       : 0,
                    lstselecionadosbaixa : [],
                    vvalorrecebimento    : 0,
                },
                baixartitulospagar       : false,

                //variaveis para detalhe do título
                didfornecedor        : '',
                dcodtit              : '',
                dsituacao            : 'A',//A - Aberto, B - Baixado, C - Cancelado, R - Renegociado

                //variável da importação
                vlimpardados            : false,
                arqselecionado          : null,    

                //variáveis para alteração do fornecedor
                aidfornecedor           : null,

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'TÍTULOS À PAGAR',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-abertos",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomefornecedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomefornecedor",
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    }, 
                    {
                        label: "Filial",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: true,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Restante",
                        name: "vlresta",
                        sort: true,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
                    {
                        label: "Atraso",
                        name: "atraso",
                        sort: true,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Juros",
                        name: "vljuros",
                        sort: true,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                                                              
                    {
                        label: "Multa",
                        name: "vlmulta",
                        sort: true,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    { 
                        label: "À pagar",
                        name: "vlapagar",
                        sort: true,
                        slot_name: "slot_vlapagar",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Categoria",
                        name: "desccategoria",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    }                                        
                ],
                columnscancelados:[
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomefornecedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomefornecedor",
                    },
                    {
                        label: "Tipo de cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                          
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: true,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Categoria",
                        name: "desccategoria",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    }                                        
                ],
                columnsbaixados:[
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomefornecedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomefornecedor",
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Pagamento",
                        name: "dtpagtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
					{
                        label: "Atraso",
                        name: "atraso",
                        sort: true,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vlresta",
                        sort: true,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Vl. Juros",
                        name: "vljuros",
                        sort: true,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Vl. Multa",
                        name: "vlmulta",
                        sort: true,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Descto(J/M)",
                        name: "valordescontojurosmulta",
                        sort: true,
                        slot_name: "slot_valordescontojurosmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
					{
                        label: "Total pago",
                        name: "vlpago",
                        sort: true,
                        slot_name: "slot_vlpago",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Conta/Fluxo",
                        name: "desccontafluxo",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccontafluxo"
                    },
                    {
                        label: "Categoria",
                        name: "desccategoria",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "F. Baixa",
                        name: "fantasiabaixa",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },  					
                ],                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    //rows_selectable: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdverificabalancoanual(){
                if (!util.opcaousuario('030Z.040Z.100Z', this.$store.state.perfilusuario)){
                    return false;
                }else {
                    return true;
                }
            },
            mtdimprimirbalanco(exc){
                let vself = this;
                window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulospagar.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&ano='+vself.vselano+
                            '&op=imprimirbalanco'+
                            '&filial='+"TODAS AS FILIAIS"+
                            '&excel='+exc+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');	

            },
            mtdbuscabalancoanual(){
                var vself       = this;                    
                let loader      = this.$loading.show();
        
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'balancoanual'},
                    {parametro: 'ano',          valor  : vself.vselano},
                 
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    vself.lstbalancofil     = response.data.listagem;
                    vself.vtotaisbalancofil = response.data.totais;
                

                    loader.hide();
                }).catch(function (response) {
                    vself.lstbalancofil = [];
                    vself.vtotaisbalancofil = [];
                    loader.hide();
                });
            },
            mtdbalancoanual(){
                this.mtdbuscabalancoanual();
                $("#mdbalancoanual").modal('show');
            },
            generateyears(startYear, endYear) {
                const yearsArray = [];
                for (let year = startYear; year <= endYear; year++) {
                    yearsArray.push(year);
                }
                return yearsArray;
            },
            mtdexcluirarquivo(patharquivo){
                let vself = this;
                let loader       = vself.$loading.show();
                let localarquivo = 'controller/arquivostitulosp/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + vself.vpatharquivostit;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Arquivo excluído com sucesso!', 'Informação!');
                        vself.lstarquivostitulo = [];
                        vself.lstarquivostitulo = response.data.arquivos;
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                  
            },
            extensaocxalta(nomearquivo) {
                var partes = nomearquivo.split('.');
                if (partes.length > 1) {
                    var extensao = partes.pop();
                    return extensao.toUpperCase();
                } else {
                    return "sem_ext";
                }
            },
            mtdselecionararquivotit(event){
                let vself = this;
                let arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivostitulosp/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + vself.vpatharquivostit;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : arqimgselecionado.name},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('arquivo enviada com sucesso!', 'Informação!');
                        vself.lstarquivostitulo = [];
                        vself.lstarquivostitulo = response.data.arquivos;
                    
                        $('#ipselecionarimg').val('');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });     
            },
            mtdpreparamodalarq(path){
                var vself       = this;
                let loader      = vself.$loading.show();
                let patharquivos= 'controller/arquivostitulosp/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + path;
                let parametros  = [
                    {parametro: 'op',               valor  : 'listararquivos'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'patharquivos',     valor  : patharquivos},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstarquivostitulo = []
                    vself.lstarquivostitulo = response.data
                    vself.vpatharquivostit  = path;
                    $('#mdlarquivostitulo').modal('show');
                    
                }).catch(function (response) {
                    loader.hide();
                });

            },
            mtdarquivostitulo(titulo){
                this.legtituloarq = titulo;
                var vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',               valor : 'verificapath'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'codtit',           valor  : titulo.codtit},
                    {parametro: 'idfornecedor',     valor  : titulo.idfornecedor},
                    {parametro: 'situacao',         valor  : vself.psituacao},
                    
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.msg)){
                        vself.mtdpreparamodalarq(response.data.path)   
                    }else{
                        let tpret = response.data.msg.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.msg.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.msg.substring(4), 'Erro!');
                                break;
                        }

                    }						
                    
                }).catch(function (response) {
                    loader.hide();
                });
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
            mtdabremodalimp(){
                this.pgrupamento  = 0;
                this.penderecocli = 0;
                this.pordemcli    = 0;
                this.pmes         = 0;
                $('#mddefineimp').modal('show');
            },
            mtdconsultarfornecedor(){
				if (parseInt(this.opcrud) < 2){
					this.vidfornecedor 	= '';
					this.vnomefornecedor 	= '';
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_FORNECEDOR_CHANGE',payload);
					let payloadx = {
						idfornecedor    : null			
					};
					this.$store.commit('FORNECEDOR_RETORNO_CHANGE',payloadx);                
				}
            },
            mtdlocalizarfornecedor(idfornecedor){
				if (idfornecedor !== '' && idfornecedor !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and f.id='+idfornecedor},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let fornecedor = response.data[0];							
							vself.vidfornecedor  			    = fornecedor.id;
							vself.vnomefornecedor 				= fornecedor.nomerazaosocial;
							$('#edcodtit').focus();
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidfornecedor 	= '';
							vself.vnomefornecedor 	= '';
							$('#edcodfor').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.vidfornecedor 	= '';
					this.vnomefornecedor 	= '';
				}
            },                        
            mtdfiltropesquisa(){
                let rfiltro = '';
                if(this.pidfilial !== null) {                    
                    rfiltro = ' and t.idfilial=' + this.pidfilial;
                }                 
                if(this.pidfornecedor !== null) {
                    rfiltro = rfiltro + ' and t.idfornecedor=' + this.pidfornecedor;
                }
                if(this.pidtipocobranca !== null) {
                    rfiltro = rfiltro + ' and t.idtipocobranca=' + this.pidtipocobranca;
                }                
                if(this.pcodauxiliar !== '') {
                    rfiltro = rfiltro + ' and t.codauxiliar="' + this.pcodauxiliar+'"';
                }
                if(this.pemitentecheque !== '') {
                    rfiltro = rfiltro + ' and upper(t.emitente) like upper("%' + this.pemitentecheque+'%")';
                }                                
				if(parseInt(this.pfiltroperiodo) === 1){
                    let strpor = parseInt(this.ppor) === 0 ? 'dtventit' : parseInt(this.ppor) === 1 ? 'dtemitit' : 'dtpagtit';
					rfiltro = rfiltro + ' and t.'+strpor+' between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                }
                if(this.pidcategoria !== null) {                    
                    rfiltro = rfiltro + ' and forn.idcategoria=' + this.pidcategoria;
                } 
                if(parseInt(this.vtipocobrancapesq)===1){
                    if(this.pidsituacaocheque !== null) {                    
                        rfiltro = rfiltro + ' and t.idsituacaocheque=' + this.pidsituacaocheque;
                    }
                }    
                if (parseInt(this.psituacao) !== 1){
                    if(parseInt(this.pativosinativos) < 2){
                        rfiltro = rfiltro + ' and t.inativo='+this.pativosinativos;
                    }
                }
                if (parseInt(this.psituacao) === 1){
                    if (this.pidconta !== null){
                        rfiltro = rfiltro + ' and cfc.id=' + this.pidconta;
                    }
                }
                switch (parseInt(this.psituacao)) {
                    case 0 :
                        rfiltro = rfiltro + ' and t.sttit in ("A", "P")';
                        break;
                    case 2 :
                        rfiltro = rfiltro + ' and t.sttit="C"';
                        break;
                    case 3 :
                        rfiltro = rfiltro + ' and t.sttit="R"';
                        break;
                }                
                return rfiltro;
            },
            mtdfiltropesquisames(){
                let rfiltro = '';
                if(this.pidfilial !== null) {                    
                    rfiltro = ' and t.idfilial=' + this.pidfilial;
                }                 
                if(this.pidfornecedor !== null) {
                    rfiltro = rfiltro + ' and t.idfornecedor=' + this.pidfornecedor;
                }
                if(this.pidtipocobranca !== null) {
                    rfiltro = rfiltro + ' and t.idtipocobranca=' + this.pidtipocobranca;
                }                
                if(this.pcodauxiliar !== '') {
                    rfiltro = rfiltro + ' and t.codauxiliar="' + this.pcodauxiliar+'"';
                }
                if(this.pemitentecheque !== '') {
                    rfiltro = rfiltro + ' and upper(t.emitente) like upper("%' + this.pemitentecheque+'%")';
                } 
                if(parseInt(this.pfiltroperiodo) === 1){
                    let strpor = parseInt(this.ppor) === 0 ? 'dtventit' : parseInt(this.ppor) === 1 ? 'dtemitit' : 'dtpagtit';
					rfiltro = rfiltro + ' and t.'+strpor+' between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                }
                if(this.pidcategoria !== null) {                    
                    rfiltro = rfiltro + ' and forn.idcategoria=' + this.pidcategoria;
                } 
                if (parseInt(this.psituacao) !== 1){
                    if(parseInt(this.pativosinativos) < 2){
                        rfiltro = rfiltro + ' and t.inativo='+this.pativosinativos;
                    }
                }
                if (parseInt(this.psituacao) === 1){
                    if (this.pidconta !== null){
                        rfiltro = rfiltro + ' and cfc.id=' + this.pidconta;
                    }
                }
                switch (parseInt(this.psituacao)) {
                    case 0 :
                        rfiltro = rfiltro + ' and t.sttit in ("A", "P")';
                        break;
                    case 2 :
                        rfiltro = rfiltro + ' and t.sttit="C"';
                        break;
                    case 3 :
                        rfiltro = rfiltro + ' and t.sttit="R"';
                        break;
                }                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'situacao',     valor  : vself.psituacao},
                    {parametro: 'ordem',        valor  : vself.pordem},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregatitulos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregatitulos(ipagina){
                var vself       = this;                    
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                vself.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table 
                vself.mtdcalculaselecionados();                   
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'situacao',     valor  : vself.psituacao},
                    {parametro: 'ordem',        valor  : vself.pordem}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(vself.pdtbasebaixa)},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    vself.lsttitulos = response.data.lista;
                    //iguala totais dos titulos para calcular os selecionados
                    if (parseInt(vself.psituacao) !== 1){
                        vself.vrVencidos        = response.data.vencidos;
                        vself.vrAvencer         = response.data.avencer;
                        vself.vrJuros           = response.data.totjuros;
                        vself.vrMulta           = response.data.totmulta;
                        vself.vrTotal           = response.data.totgeral;
                        vself.vrTotcancelados   = response.data.totcancelados;                        
                    }else{
                        vself.vtotaltitulosrec  = response.data.totaltitulos;
                        vself.vtotaljurosrec    = response.data.totaljuros;
                        vself.vtotalmultarec    = response.data.totalmulta;
                        vself.vtotaldescontorec = response.data.totaldescontos;
                        vself.vtotalgeralrec    = response.data.totgeral;                             
                    }
                    loader.hide();
                }).catch(function (response) {
                    vself.lsttitulos = [];
                    loader.hide();
                });
            },
            mtdselect2_def(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                
                
				let sqliniconta = 'select * from tbcontasfluxocaixa ';
				let sqlfimconta = vself.filiaisusuario !== '' ? 'where upper(descricao) like upper("%@@%") and idfilial in ('+vself.filiaisusuario+')' : 'where upper(descricao) like upper("%@@%")';                                

				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbfornecedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesq").val();
                    vself.mtdlimpar_listagem();
				});
                
				$("#cbcategoriapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcategorias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcategoria = $("#cbcategoriapesq").val();
                });
                                
				$("#cbtipocobrancapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidtipocobranca = $("#cbtipocobrancapesq").val();
                    if (vself.pidtipocobranca !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.pidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.vtipocobrancapesq = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.vtipocobrancapesq = 0;
                            loader.hide();
                        });
                    }else{
                        vself.vtipocobrancapesq = 0;
                    }  
                });  
                $("#cbsitchequepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidsituacaocheque = $("#cbsitchequepesq").val();
                    vself.mtdlimpar_listagem();
                });              
                
                $("#cbcontapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,						
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q		: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    sqlini	: sqliniconta,
                                    sqlfim	: sqlfimconta,
                                    cpid	: 'id',
                                    cpdesc	: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidconta = $("#cbcontapesq").val();
                });

                //selects crud
				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.vidtipocobranca !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.tipocob = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.tipocob = 0;
                            loader.hide();
                        });
                    }else{
                        vself.tipocob = 0;
                    }
                });
				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
                });
				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbanco = $("#cbbanco").val();
                });
				$("#cbsitcheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidsituacaocheque = $("#cbsitcheque").val();
                });
                
				$("#cbfornecedoralterar").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.aidfornecedor = $("#cbfornecedoralterar").val();
				}); 
                
				$('#mdalterarfornecedor').on('shown.bs.modal', function (e) {                    
					$('#cbfornecedoralterar').select2('open');
                });  
                $("#mdBaixarTitulosPagar").on('hide.bs.modal', function () {
                    vself.baixartitulospagar = false;
                });              
            },
            resetarDados() {
                util.toTop();

                this.tipocob             = 0;

                this.vidfornecedor          = '';
                this.vnomefornecedor        = '';
                this.vcodtit             = '';
                this.vsttit              = '';
                this.vcodauxiliar        = '';
                this.vidtipocobranca     = null;
                this.vidfilial           = null;
                this.vdtemitit           = util.DataAtual(true);
                this.vdtventit           = util.DataAtual(true);
                this.vnumerocheque       = '';
                this.vidbanco            = null;
                this.vagencia            = '';
                this.vconta              = '';
                this.vpraca              = '';
                this.vemitente           = '';
                this.vcnpjcpf            = '';
                this.vidsituacaocheque   = null;
                this.vinativo            = 0;
                this.vtpcalcjuros        = 0;
                this.vfatjuros           = 0;
                this.vtpcalcmulta        = 0;
                this.vfatmulta           = 0;
                this.vvltit              = 0;
                this.vobstit             = '';

                $("#cbfilial").val(null).trigger('change');
                $("#cbtipocobranca").val(null).trigger('change');
                $("#cbbanco").val(null).trigger('change');
                $("#cbsitcheque").val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#edcodfor').focus();
                    } else if(parseInt(this.opcrud) === 2){
                        $('#edauxiliar').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
                if (parseInt(op) > 1) {
                    vself.ativadesativaCodFor = true;
                    vself.ativadesativaCodTit = true;
                }else{
                    vself.ativadesativaCodFor = false;
                    vself.ativadesativaCodTit = false;
                }
            },
            mtdnovo(){
                if (!util.opcaousuario('030Z.040Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE TÍTULO À PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lsttitulos             = [];
                this.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table
                this.pagina_atual           = 1;
                this.filtro                 = '';
                this.pqtd_total_registros   = 0;
                this.pqtd_paginas           = 0;
                this.pidconta               = null;
                this.vrVencidos             = 0;
                this.vrAvencer              = 0;
                this.vrJuros                = 0;
                this.vrMulta                = 0;
                this.vrTotal                = 0;
                this.vrTotcancelados        = 0;
                //variáveis dos baixados    
                this.vtotaltitulosrec       = 0;
                this.vtotaljurosrec         = 0;
                this.vtotalmultarec         = 0;
                this.vtotaldescontorec      = 0;
                this.vtotalgeralrec         = 0; 
                
                $('#cbcontapesq').val(null).trigger('change');

                this.mtdcalculaselecionados();
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(idfornecedor, codtit){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and t.idfornecedor='+idfornecedor+' and t.codtit="'+codtit+'"';
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.lista[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('030Z.040Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE TÍTULO À PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.idfornecedor, item.codtit);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('030Z.040Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CANCELAMENTO DE TÍTULO À PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.idfornecedor, item.codtit);
                }
            },
            mtdigualarcampos(registro){
                    this.vidfornecedor           = registro.idfornecedor;
                    this.vnomefornecedor         = registro.nomefornecedor;
                    this.vcodtit              = registro.codtit;
                    this.vcodauxiliar         = registro.codauxiliar;
                    this.vsttit               = registro.sttit;
                    this.vidtipocobranca      = registro.idtipocobranca;
                    this.vtipocobranca        = registro.ipocob;  
                    this.vdtemitit            = registro.dtemitit;
                    this.vdtventit            = registro.dtventit;
                    this.vdtpagtit            = registro.dtpagtit;
                    this.vvltit               = registro.vltit;
                    this.vvlresta             = registro.vlresta;
                    this.vtpcalcjuros         = registro.tpcalcjuros;
                    this.vtpcalcmulta         = registro.tpcalcmulta;
                    this.vfatjuros            = registro.fatjuros;
                    this.vfatmulta            = registro.fatmulta;
                    this.vobstit              = registro.obstit;
                    this.vobstitsis           = registro.obstitsis;
                    this.vnumerocheque        = registro.numerocheque;
                    this.vidbanco             = registro.idbanco;
                    this.vagencia             = registro.agencia;
                    this.vconta               = registro.conta;
                    this.vpraca               = registro.praca;
                    this.vcnpjcpf             = registro.cnpjcpf;
                    this.vemitente            = registro.emitente,
                    this.vidsituacaocheque    = registro.idsituacaocheque;
                    this.vidfilial            = registro.idfilial;
                    this.vvlpagtit            = registro.vlpagtit;
                    this.vnossonumero         = registro.nossonumero;
                    this.vultimojuros         = registro.ultimojuros;
                    this.vdtultpagtit         = registro.dtultpagtit;
                    this.vinativo             = registro.inativo;

                    var deffilial        = new Option(registro.fantasia, registro.idfilial, true, true);
                    $('#cbfilial').append(deffilial).trigger('change');

                    var deftipocobranca  = new Option(registro.desccob, registro.idtipocobranca, true, true);
                    $('#cbtipocobranca').append(deftipocobranca).trigger('change');
                   
                    if (parseInt(registro.tipocobranca) === 1){
                        var defbanco    = new Option(registro.descbanco, registro.idbanco, true, true);
                        $('#cbbanco').append(defbanco).trigger('change');

                        var defsitch    = new Option(registro.descsitch, registro.idsituacaocheque, true, true);
                        $('#cbsitcheque').append(defsitch).trigger('change');                        
                    }else{
                        $("#cbbanco").val(null).trigger('change');
                        $("#cbsitcheque").val(null).trigger('change');
                    }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let fantasiafilial = $('#cbfilial').select2('data')[0]['text'];
                let nomefornecedor    = vself.vnomefornecedor; 
                let registrocrud = {
                    'idfornecedor'           : this.vidfornecedor,
                    'codtit'              : this.vcodtit,
                    'codauxiliar'         : this.vcodauxiliar,
                    'sttit'               : this.vsttit,
                    'idtipocobranca'      : this.vidtipocobranca,
                    'tipocobranca'        : this.tipocob,  
                    'dtemitit'            : this.vdtemitit,
                    'dtventit'            : this.vdtventit,
                    'dtpagtit'            : this.vdtpagtit,
                    'vltit'               : this.vvltit,
                    'vlresta'             : this.vvlresta,
                    'tpcalcjuros'         : this.vtpcalcjuros,
                    'tpcalcmulta'         : this.vtpcalcmulta,
                    'fatjuros'            : this.vfatjuros,
                    'fatmulta'            : this.vfatmulta,
                    'obstit'              : this.vobstit,
                    'obstitsis'           : this.vobstitsis,
                    'numerocheque'        : this.vnumerocheque,
                    'idbanco'             : this.vidbanco,
                    'agencia'             : this.vagencia,
                    'conta'               : this.vconta,
                    'praca'               : this.vpraca,
                    'cnpjcpf'             : this.vcnpjcpf !== null || this.vcnpjcpf !== "" ? this.vcnpjcpf.replace(/[^0-9]/g,'') : "",
                    'emitente'            : this.vemitente,
                    'idsituacaocheque'    : this.vidsituacaocheque === null ? 0 : this.vidsituacaocheque,
                    'idfilial'            : this.vidfilial,
                    'vlpagtit'            : this.vvlpagtit,
                    'ultimojuros'         : this.vultimojuros,
                    'dtultpagtit'         : this.vdtultpagtit,
                    'inativo'             : this.vinativo
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '030Z.040Z.010Z' : parseInt(this.opcrud) === 2 ? '030Z.040Z.020Z' : '030Z.040Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pidfilial      = registrocrud.idfilial;
                        vself.pidfornecedor     = registrocrud.idfornecedor;
                        vself.pcodauxiliar   = '';
                        vself.pfiltroperiodo = 0;
                        vself.ppor           = 0;
                        vself.pativosinativos= 2;
                        vself.psituacao      = 0;
                        vself.pordem         = 2;
                        vself.pqtd_paginas   = 1;

                        var deffilial        = new Option(fantasiafilial, registrocrud.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');

                        var deffornecedor       = new Option(nomefornecedor, registrocrud.idfornecedor, true, true);
                        $('#cbfornecedorpesq').append(deffornecedor).trigger('change');                        

                        vself.mtdcancelaredicao();
                        vself.mtdcarregatitulos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdzerarselecionados() {
                this.vTotalPagarSel       = 0;
                this.vTotalJurosSel       = 0;
                this.vTotalMultaSel       = 0;
                this.vTotalGeralSel       = 0;
            },            
            mtdcalculaselecionados() {
                this.mtdzerarselecionados();
                for (var i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
                    this.vTotalPagarSel    = this.vTotalPagarSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                    this.vTotalJurosSel    = this.vTotalJurosSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                    this.vTotalMultaSel    = this.vTotalMultaSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
                    this.vTotalGeralSel    = this.vTotalGeralSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlapagar);
                }
                this.vqtdtitsel = this.$refs.reflsttitulos.selected_items.length;
            },
            mtdbaixartitulos(){
                if (!util.opcaousuario('030Z.040Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (parseInt(this.pordem) !== 2){
                        this.$toastr.w('Para baixa, a ordem dos títulos deve estar por data de vencimento!', 'Atenção!');
                        $("#cbordempesq").focus();
                        return;
                    }
                    if (this.pdtbasebaixa === null){
                        this.$toastr.w('Data da baixa deve ser informada!', 'Atenção!');
                        $("#eddtbasebaixa").focus();
                        return;
                    }                    
                    this.vvariaveisbaixar.vtottitbaixa         = this.vTotalPagarSel;
                    this.vvariaveisbaixar.vtotjurosbaixa       = this.vTotalJurosSel;
                    this.vvariaveisbaixar.vtotmultabaixa       = this.vTotalMultaSel;
                    this.vvariaveisbaixar.vtotpagarbaixa       = this.vTotalGeralSel;
                    this.valdescontojuros                      = this.vTotalJurosSel;
                    this.valdescontomulta                      = this.vTotalMultaSel;
                    this.vvariaveisbaixar.lstselecionadosbaixa = this.$refs.reflsttitulos.selected_items;
                    this.vvariaveisbaixar.vvalorrecebimento    = this.vTotalGeralSel;


                    this.baixartitulospagar  =  true

                    setTimeout(() => {
                        $('#mdBaixarTitulosPagar').modal('show');
                    }, 500);
                 
                }
            },
            mtdestornarbaixa(titulo){
                let vself = this;
                if (!util.opcaousuario('030Z.040Z.060Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Esse processo irá estornar, também, todos os pagamentos feitos depois deste. Deseja mesmo realizar o estorno do pagamento do título "'+titulo.codtit+'"?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'estornarbaixa'},
                                        {parametro: 'idmovip',      valor : titulo.id},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.040Z.060Z'}
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Título estornado com sucesso!', 'Informação!');
                                            //reaproveitei o payload da baixa ;)
                                            let payload = {
                                                retorno    : 1
                                            };
                                            vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);                        
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'A':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }                    
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }
            },
            mtdestornarcancelamento(titulo){
                let vself = this;
                if (!util.opcaousuario('030Z.040Z.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma estorno de cancelamento do título "'+titulo.codtit+'"?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'estornarcancelamento'},
                                        {parametro: 'codtit',       valor : titulo.codtit},
                                        {parametro: 'idfornecedor',    valor : titulo.idfornecedor},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.010Z.050Z'}
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Título estornado com sucesso!', 'Informação!');
                                            //reaproveitei o payload da baixa ;)
                                            let payload = {
                                                retorno    : 1
                                            };
                                            vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);                        
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'A':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }                    
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }
            },
            mtddetalhestitulo(idfornecedor, codtit, situacao){
                if (!util.opcaousuario('030Z.040Z.070Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    this.didfornecedor  = idfornecedor;
                    this.dcodtit        = codtit;
                    this.dsituacao      = situacao;
                    $('#mdDetalhesTitulosPagar').modal('show');
                }
            },
            mtdgerarpdf(exc){
                let vself   = this;
                let filtro  = ""

                if(parseInt(vself.pgrupamento) === 4){
                    filtro  =  vself.mtdfiltropesquisames();
                }else{
                    filtro  =  vself.mtdfiltropesquisa();
                }

                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
                
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulospagar.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro+
                            '&op=imprimirlistagem'+
                            '&filial='+filial+
                            '&situacao='+vself.psituacao+
                            '&dtbasecalculo='+util.InverterData(vself.pdtbasebaixa)+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
                            '&mostraend='+vself.penderecocli+
                            '&ordemcli='+vself.pordemcli+
                            '&mes='+vself.pmes+
                            '&agrupamento='+vself.pgrupamento+
                            '&excel='+exc+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&ordem='+vself.pordem, '_blank');					                
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('030Z.040Z.080Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO DE CONTAS À PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado = null;
                    this.vlimpardados   = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarcp.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstclientes= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarcp.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&codop=030Z.040Z.080Z';
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdgerarparcelas(){
                if (!util.opcaousuario('030Z.040Z.090Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                                                     
                    $('#mdgerarparcelas').modal('show');
                }
            },
            mtdalterarfornecedor(){
                if (this.$refs.reflsttitulos.selected_items.length === 0){
                    this.$toastr.w('Selecione os títulos para alteração!', 'Informação!');
                    return;
                }
                if (!util.opcaousuario('030Z.040Z.095Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {       
                    $("#cbfornecedoralterar").val(null).trigger('change');         
                    $('#mdalterarfornecedor').modal('show');
                }                
            },
            mtdgravarfornecedor(){
                let vself = this;
                if (vself.aidfornecedor === null){
                    this.$toastr.w('Informe o fornecedor!', 'Atenção!');
                    $("#cbfornecedoralterar").select2('open');
                    return;
                }

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma alteração do fornecedor no(s) título(s) selecionado(s)?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);

                                let loader = vself.$loading.show();

                                let parametros      = [
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'alterarfornecedor'},
                                    {parametro: 'idfornecedor', valor : vself.aidfornecedor},
                                    {parametro: 'titulos',      valor : JSON.stringify(vself.$refs.reflsttitulos.selected_items)},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'codop',        valor : '030Z.040Z.095Z'}
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if ($.isNumeric(response.data)){
                                        $('#mdalterarfornecedor').modal('hide');
                                        vself.$toastr.s('Títulos alterados com sucesso!', 'Informação!');
                                        vself.pcodauxiliar   = '';
                                        vself.pfiltroperiodo = 0;
                                        vself.ppor           = 0;
                                        vself.pativosinativos= 2;
                                        vself.psituacao      = 0;
                                        vself.pordem         = 2;
                                        vself.pqtd_paginas   = 1;
                                        vself.mtdlimpar_listagem();
                                        vself.mtdcarregatitulos(1);                 
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }                    
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    $('#mdalterarfornecedor').modal('hide');
                                });                                

                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });                
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself           = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader          = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',           valor : 'dadosusuario'},
                    {parametro: 'idclientesac', valor : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                            position: 'bottom-end',
                            //icon: 'success',
                            title: 'Atenção!',
                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                            showConfirmButton: false,
                            showCloseButton: true,
                            backdrop: false                                                
                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
                    if (util.opcaousuario('030Z.040Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                if(parseInt(this.tipocob) === 0) {
                    return  this.vcodtit === '' || this.vidtipocobranca === null || this.vidfilial === null ||
                            this.vvltit === 0 || this.vdtemitit === '' || this.vdtventit === '';
                }else{
                    return  this.vcodtit === '' || this.vidtipocobranca === null || this.vidfilial === null ||
                            this.vvltit === 0 || this.vnumerocheque === '' ||
                            this.vidbanco === null || this.vagencia === '' || this.vconta === '' ||
                            this.vpraca === '' || this.vemitente === '' || this.vcnpjcpf === '' || this.vidsituacaocheque === null || 
                            this.vdtemitit === '' || this.vdtventit === '';
                }
            },
            idfornecedorretorno(){
                return this.$store.state.fornecedorretornoconsulta.idfornecedor;
			},            
			selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            retornobaixa(){
               return this.$store.state.retornobaixapagar.retorno; 
            }
        },
        watch:{
            idfornecedorretorno(val){
                if (val !== null || val !== ''){
					this.vidfornecedor = val;
					this.mtdlocalizarfornecedor(this.vidfornecedor);					
                }
			},            
            pagina_atual(val){
                this.mtdcarregatitulos(val);
            },
            psituacao(val){
                this.config.checkbox_rows = parseInt(val) === 0 ? true : false;
            },
            retornobaixa(val){
                let vself = this;
                if (parseInt(val) === 1){
                    //dispara a mutation pra esperar pela próxima baixa
                    let payload = {
                        retorno    : 0
                    };
                    vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);
                    vself.pcodauxiliar   = '';
                    vself.pfiltroperiodo = 0;
                    vself.ppor           = 0;
                    vself.pativosinativos= 2;
                    vself.psituacao      = 0;
                    vself.pordem         = 2;
                    vself.pqtd_paginas   = 1;
                    vself.mtdlimpar_listagem();
                    vself.mtdcarregatitulos(1);                    
                }
            },
            psituacao(val){
                if (parseInt(val) === 1){
                    this.pordem = 2;
                }
            }                        
        }
    }
</script>
<style>
    .def-col-opcoes-abertos{
        width: 130px !important;
    }
    .def-col-codtit{
        width: 120px !important;
    }
    .lstdetrec{
        padding: 5px!important;
        font-weight: 700;
        color: #6c757d!important;
    }
    .bdgtitulos{
        margin-top: 2px;
        float : right!important;
        font-size: 12px!important;
        width: 100px!important;
        text-align: right!important;
    } 
    
  
      
      .table-anual tbody td {
        font-size: 10px; /* Diminui o tamanho da fonte dos itens */
      }   
</style>